module.exports = __webpack_public_path__ + "static/img/cubby.c28bfcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/cubby.svg
// module id = ITbx
// module chunks = 2